import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FiMenu, FiX, FiUser } from 'react-icons/fi';
import './Header.css';

const Header = () => {
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Set dark theme on mount
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark');
  }, []);

  // Navigation links based on user type
  const getNavLinks = () => {
    const baseLinks = [
      { to: '/', label: 'עמוד הבית', end: true },
    ];

    // All users (guest, admin, creator, brand) see full menu
    return [
      ...baseLinks,
      { to: '/campaigns', label: 'קמפיינים' },
      { to: '/about', label: 'אודות' },
      { to: '/contact', label: 'צור קשר' },
    ];
  };

  const navLinks = getNavLinks();

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        {/* Logo - Right Side */}
        <Link to="/" className="logo">
          <img
            src="/logo.png"
            alt="Weon"
            className="logo-img"
          />
        </Link>

        {/* Navigation - Center */}
        <nav className="header-nav">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              className={({ isActive }) =>
                `nav-link ${isActive ? 'active' : ''}`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        {/* Action Buttons - Left Side */}
        <div className="header-actions">
          {user ? (
            <Link to="/dashboard" className="btn-header-primary">
              <FiUser />
              <span>אזור אישי</span>
            </Link>
          ) : (
            <>
              <Link to="/creator-login" className="btn-header-glass">
                התחבר
              </Link>
              <Link to="/register?type=creator" className="btn-header-primary">
                הצטרפו כיוצרים
              </Link>
              <Link to="/register?type=brand" className="btn-header-outline-orange">
                מותג? התחל קמפיין
              </Link>
            </>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="mobile-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="תפריט"
        >
          {mobileMenuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <nav className="mobile-nav">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  `mobile-nav-link ${isActive ? 'active' : ''}`
                }
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="mobile-actions">
            {user ? (
              <Link
                to="/dashboard"
                className="btn-header-primary mobile-btn"
                onClick={() => setMobileMenuOpen(false)}
              >
                <FiUser />
                <span>אזור אישי</span>
              </Link>
            ) : (
              <>
                <Link
                  to="/creator-login"
                  className="btn-header-glass mobile-btn"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  התחבר
                </Link>
                <Link
                  to="/register?type=creator"
                  className="btn-header-primary mobile-btn"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  הצטרפו כיוצרים
                </Link>
                <Link
                  to="/register?type=brand"
                  className="btn-header-outline-orange mobile-btn"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  מותג? התחל קמפיין
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
